// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const t = require('app/scripts/views/internal/teacup-with-helpers')(
  'sync_error',
);

module.exports = function () {
  t.format('you-have-been-disconnected-from-the-trello-server-for-too-long');
  t.br();
  return t.a(
    '.app-alert-item-button',
    { href: '#', onclick: 'window.location.reload();' },
    () => t.format('reload-now'),
  );
};
